// extracted by mini-css-extract-plugin
export default {"admin":"admin_admin__-0O7w"};